import React from "react"
import { HeaderSection } from "../../common/headers/HeaderSection";
import BootcampScheduleSection from "./BootcampBanner";

const BootcampFullStackEngineerSchedule = () => {
    /*const [bootcampSchedules, setBootcampSchedules] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('');
                const data = await response.json();
                setBootcampSchedules(data);
            } catch (error) {
                console.error('Error fetching data:');
            }
        };

        fetchData();
    }, []);*/

    // Using manual data temporarily, as the API is still pending.
    const bootcampSchedules = [
        {
            id: 1,
            programStart: 'Dimulai bulan Maret 2024',
        },
    ];

    return (
        <div className="px-5 md:px-10">
            <HeaderSection
                title="Jadwal Program"
                subtitle="Pilih dan daftar jadwal program yang tersedia"
            />
            <BootcampScheduleSection schedule={bootcampSchedules} />
        </div>
    );
};

export default BootcampFullStackEngineerSchedule;